import bearer from '../config/bearer';

export default {
  async update(customerId, objectiveId, hno) {
    if (customerId == 'admin') {
      return;
    }
    const url = `customers/${customerId}/update/objectives/${objectiveId}`;

    return await bearer
      .put(url, { hno })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        return {};
      });
  },
};
